export default {
  'menu.welcome': '欢迎',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理后台',
  'menu.admin.sub-page': '二级管理页',
  // 首页
  'menu.admin.dashboard': '首页',
  // 用户管理
  'menu.admin.user-list': '用户列表',
  'menu.admin.kyc': 'KYC管理',
  'menu.admin.user-detail': '用户详情',
  'menu.admin.user-keys': 'API Key 管理',
  // VCC管理
  'menu.admin.vcc-products': '产品管理',
  'menu.admin.vcc-applications': '卡片申请',
  'menu.admin.vcc-cards': '卡片管理',
  // 钱包管理
  'menu.admin.wallet-records': '充提记录',
  'menu.admin.wallet-history': '历史记录',
  'menu.admin.withdraw-config': '提现设置',
  // 汇兑管理
  'menu.admin.swap-manage': '兑换管理',
  'menu.admin.swap-orders': '兑换订单',
  // 分销管理
  'menu.admin.commission': '佣金管理',
  // 系统管理
  'menu.admin.roles': '角色管理',
  'menu.admin.operation-logs': '操作日志',
  // 旧菜单（保留兼容）
  'menu.admin.user-manage': '用户管理',
  'menu.admin.role-manage': '角色权限',
  'menu.admin.kyc-manage': 'KYC管理',
  'menu.admin.card-manage': '卡片管理',
  'menu.admin.card-application': '卡片申请',
  'menu.admin.user-cards': '用户卡片',
  'menu.admin.commission-manage': '返佣管理',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.wallet': '充提管理',
  'menu.wallet.records': '充提记录',
  'menu.wallet.history': '历史记录',
  'menu.account': '个人页',
  'menu.account.center': '邀请中心',
  'menu.account.settings': '个人设置',
  'menu.account.card-center': '卡片中心',
  'menu.account.assets': '我的资产',
  'menu.account.my-cards': '卡片申请',
  'menu.account.user-cards': '我的卡片',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
  // 全局管理
  'menu.global': '全局管理',
  'menu.global.finance': '资金明细',
  'menu.global.users': '用户管理',
  'menu.global.deposits': '充值管理',
  'menu.global.custody-products': '托管产品',
  'menu.global.custody-orders': '托管订单',
  'menu.global.withdrawals': '提现管理',
  'menu.global.commission-config': '返佣配置',
  'menu.global.commission-records': '返佣记录',
  'menu.global.commission-vesting': '佣金归属',
  'menu.global.team-performance': '团队业绩',
};
